import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'configuration-accelerators-tab-2-part',
	standalone: true,
	templateUrl: './configuration-accelerators-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./configuration-accelerators-tab-2.part.scss`],
})
export class ConfigurationAcceleratorsTab2Part {
}
